module.exports = __webpack_public_path__ + "img/男-肺癌h.a303b661.png";